export default __webpack_public_path__ + "static/media/009-crosswalk.6bd3e9d6.svg";